module.exports = __webpack_public_path__ + "static/media/combo_ride_5.81f83c2f.png";